"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.log = exports.FINGERPRINT = exports.AvroOptional = void 0;
const signals_logger_1 = require("@indeed/signals-logger");
var signals_logger_2 = require("@indeed/signals-logger");
Object.defineProperty(exports, "AvroOptional", { enumerable: true, get: function () { return signals_logger_2.AvroOptional; } });
exports.FINGERPRINT = "8f7c984a7501adfd";
function log(message) {
    (0, signals_logger_1.log)(exports.FINGERPRINT, message);
}
exports.log = log;
